import type { enBoApPayments } from '../en/bo-ap-payments';

export const idBoApPayments: Record<keyof typeof enBoApPayments, string> = {
  // ---- Pembayaran
  'bo.ap.pay.title': 'Pembayaran pemasok',
  'bo.ap.pay.subtitle':
    'Pembayaran ke pemasok di {branch}, dialokasikan ke faktur yang sudah diposting',
  'bo.ap.pay.noBranch': 'Pembayaran dicatat per cabang.',
  'bo.ap.pay.add': 'Catat pembayaran',
  'bo.ap.pay.readOnly':
    'Anda dapat melihat pembayaran. Mencatat pembayaran memerlukan izin "kelola hutang".',
  'bo.ap.pay.readOnlyVerifier':
    'Anda memverifikasi atau menolak pembayaran yang dicatat orang lain. Mencatat pembayaran memerlukan izin "kelola hutang".',
  'bo.ap.pay.noPermission': 'Peran Anda tidak dapat melihat pembayaran pemasok di cabang ini.',
  'bo.ap.pay.listTitle': 'Daftar pembayaran',
  'bo.ap.pay.listDesc':
    'Terbaru di atas. Pembayaran baru mengurangi faktur setelah diverifikasi oleh orang lain.',
  'bo.ap.pay.filterLabel': 'Saring menurut status',
  'bo.ap.pay.empty':
    'Belum ada pembayaran — akan muncul di sini setelah bagian keuangan mencatatnya.',
  'bo.ap.pay.emptyManage':
    'Belum ada pembayaran — catat pembayaran untuk faktur yang sudah diposting lewat "Catat pembayaran".',
  'bo.ap.pay.emptyFiltered': 'Tidak ada pembayaran dengan status ini.',
  'bo.ap.pay.col.number': 'Nomor',
  'bo.ap.pay.col.supplier': 'Pemasok',
  'bo.ap.pay.col.channel': 'Metode',
  'bo.ap.pay.col.reference': 'Referensi',
  'bo.ap.pay.col.date': 'Tanggal bayar',
  'bo.ap.pay.col.amount': 'Jumlah',
  'bo.ap.pay.col.status': 'Status',
  'bo.ap.pay.col.recordedBy': 'Dicatat oleh',
  'bo.ap.pay.col.verifiedBy': 'Diverifikasi oleh',
  'bo.ap.pay.col.actions': 'Verifikasi',
  'bo.ap.pay.allocationsOf': 'Alokasi {number}',
  'bo.ap.pay.rejectedBecause': 'Alasan: {reason}',
  'bo.ap.pay.you': 'Anda',
  'bo.ap.pay.ownPayment': 'Anda yang mencatat pembayaran ini — verifikator lain yang memutuskan.',
  'bo.ap.pay.sodNote':
    'Pemisahan tugas: pembayaran diverifikasi atau ditolak oleh orang lain, bukan oleh pencatatnya.',
  'bo.ap.pay.channel.bank_transfer': 'Transfer bank',
  'bo.ap.pay.channel.cash': 'Tunai',
  'bo.ap.pay.channel.giro': 'Giro',
  'bo.ap.pay.channel.other': 'Lainnya',
  'bo.ap.pay.status.pending_verification': 'Menunggu verifikasi',
  'bo.ap.pay.status.verified': 'Terverifikasi',
  'bo.ap.pay.status.rejected': 'Ditolak',
  'bo.ap.pay.verify': 'Verifikasi',
  'bo.ap.pay.verifying': 'Memverifikasi…',
  'bo.ap.pay.reject': 'Tolak',
  'bo.ap.pay.rejecting': 'Menolak…',
  'bo.ap.pay.verifyTitle': 'Verifikasi pembayaran',
  'bo.ap.pay.verifyBody': '{number} ke {supplier}:',
  'bo.ap.pay.verifyEffect':
    'Periksa dulu bukti transfer atau kas. Verifikasi menerapkan alokasi: sisa tagihan faktur berkurang dan tidak bisa diubah lagi.',
  'bo.ap.pay.rejectTitle': 'Tolak pembayaran',
  'bo.ap.pay.rejectEffect':
    'Alokasi dilepas; faktur tetap terbuka untuk pembayaran yang sudah diperbaiki.',
  'bo.ap.pay.rejectReason': 'Alasan',
  'bo.ap.pay.rejectReasonHint': 'Ditampilkan ke pencatat, mis. "Bukti transfer salah".',
  'bo.ap.pay.verified': 'Pembayaran {number} terverifikasi.',
  'bo.ap.pay.rejected': 'Pembayaran {number} ditolak.',
  'bo.ap.pay.recorded': 'Pembayaran {number} tercatat — menunggu verifikasi.',
  'bo.ap.pay.refusal.self':
    'Anda yang mencatat pembayaran ini; orang lain yang harus memverifikasi atau menolaknya.',
  'bo.ap.pay.refusal.permission': 'Peran Anda tidak dapat memverifikasi pembayaran pemasok.',
  'bo.ap.pay.createTitle': 'Catat pembayaran',
  'bo.ap.pay.createDesc': 'Satu pembayaran ke satu pemasok, dibagi ke faktur-faktur terbukanya.',
  // ---- Formulir pembayaran
  'bo.ap.pay.form.explain':
    'Setiap rupiah pembayaran dialokasikan ke faktur. Jumlah alokasi harus sama persis dengan jumlah pembayaran.',
  'bo.ap.pay.form.supplier': 'Pemasok',
  'bo.ap.pay.form.supplierPick': 'Pilih pemasok',
  'bo.ap.pay.form.supplierHint': 'Faktur terposting yang belum lunas muncul di bawah.',
  'bo.ap.pay.form.supplierRequired': 'Pilih pemasok yang Anda bayar.',
  'bo.ap.pay.form.channel': 'Metode pembayaran',
  'bo.ap.pay.form.reference': 'Referensi',
  'bo.ap.pay.form.referenceHint': 'Nomor transfer atau nomor giro, sesuai bukti.',
  'bo.ap.pay.form.date': 'Tanggal bayar',
  'bo.ap.pay.form.dateHint': 'Tanggal bisnis di {timeZone}.',
  'bo.ap.pay.form.dateRequired': 'Isi tanggal pembayaran.',
  'bo.ap.pay.form.amount': 'Jumlah ({currency})',
  'bo.ap.pay.form.amountHint': 'Hanya angka, dalam satuan mata uang terkecil.',
  'bo.ap.pay.form.amountPreview': 'Jumlah:',
  'bo.ap.pay.form.amountRequired': 'Isi jumlah lebih dari nol.',
  'bo.ap.pay.form.allocTitle': 'Alokasi ke faktur',
  'bo.ap.pay.form.allocDesc':
    'Sisa terbuka = sisa tagihan − alokasi pembayaran lain yang masih menunggu verifikasi.',
  'bo.ap.pay.form.autoAllocate': 'Alokasikan mulai jatuh tempo terlama',
  'bo.ap.pay.form.pickSupplierFirst': 'Pilih pemasok untuk melihat faktur terbukanya.',
  'bo.ap.pay.form.noOpenInvoices':
    'Pemasok ini tidak punya faktur terbuka — hanya faktur terposting yang belum lunas yang bisa dibayar.',
  'bo.ap.pay.form.col.invoice': 'Faktur',
  'bo.ap.pay.form.col.due': 'Jatuh tempo',
  'bo.ap.pay.form.col.outstanding': 'Sisa tagihan',
  'bo.ap.pay.form.col.pending': 'Menunggu verifikasi',
  'bo.ap.pay.form.col.remaining': 'Sisa terbuka',
  'bo.ap.pay.form.col.allocation': 'Alokasi',
  'bo.ap.pay.form.supplierInvoice': 'No. pemasok {number}',
  'bo.ap.pay.form.allocLabel': 'Alokasi ke {number}',
  'bo.ap.pay.form.fillFull': 'Isi penuh',
  'bo.ap.pay.form.fillFullFor': 'Alokasikan seluruh sisa terbuka ke {number}',
  'bo.ap.pay.form.fullyPending': 'Sudah teralokasi penuh ke pembayaran yang menunggu verifikasi.',
  'bo.ap.pay.form.exceeds': 'Melebihi sisa terbuka.',
  'bo.ap.pay.form.allocInvalid': 'Isi jumlah bulat.',
  'bo.ap.pay.form.overAllocated':
    'Pembayaran lain sudah mengambil sebagian faktur ini; sisa terbuka kini {open}.',
  'bo.ap.pay.form.notPayable': 'Faktur ini tidak bisa dibayar lagi. Muat ulang lalu coba lagi.',
  'bo.ap.pay.form.allocated': 'Total alokasi',
  'bo.ap.pay.form.amountTotal': 'Jumlah pembayaran',
  'bo.ap.pay.form.difference': 'Selisih',
  'bo.ap.pay.form.diffNoAmount': 'Isi jumlah pembayaran, lalu alokasikan.',
  'bo.ap.pay.form.diffNone': 'Alokasikan jumlah ke minimal satu faktur.',
  'bo.ap.pay.form.diffBalanced': 'Alokasi sudah sama dengan jumlah pembayaran.',
  'bo.ap.pay.form.diffShort': 'Masih {amount} yang belum dialokasikan.',
  'bo.ap.pay.form.diffOver': 'Alokasi melebihi jumlah pembayaran sebesar {amount}.',
  'bo.ap.pay.form.serverMismatch': 'Jumlah alokasi harus sama dengan jumlah pembayaran.',
  'bo.ap.pay.form.sodNote':
    'Setelah disimpan, pembayaran menunggu verifikasi oleh orang lain; faktur belum berkurang sampai saat itu.',
  'bo.ap.pay.form.submit': 'Catat pembayaran',
  'bo.ap.pay.form.submitting': 'Mencatat…',
  // ---- Umur hutang
  'bo.ap.aging.title': 'Umur hutang',
  'bo.ap.aging.subtitle':
    'Faktur pemasok yang masih terbuka di {branch} menurut lama keterlambatan',
  'bo.ap.aging.noBranch': 'Umur hutang dilaporkan per cabang.',
  'bo.ap.aging.noPermission': 'Peran Anda tidak dapat melihat hutang di cabang ini.',
  'bo.ap.aging.asOfTitle': 'Tanggal laporan',
  'bo.ap.aging.asOfDesc': 'Saldo seperti pada akhir hari tersebut.',
  'bo.ap.aging.asOf': 'Per tanggal',
  'bo.ap.aging.today': 'Hari ini',
  'bo.ap.aging.listTitle': 'Hutang terbuka per {date}',
  'bo.ap.aging.listDesc':
    'Per pemasok, terbesar di atas. Tanggal dalam {timeZone}. Buka baris untuk melihat fakturnya.',
  'bo.ap.aging.empty':
    'Tidak ada hutang terbuka per {date} — faktur terposting yang masih bersaldo akan muncul di sini.',
  'bo.ap.aging.col.supplier': 'Pemasok',
  'bo.ap.aging.col.total': 'Total',
  'bo.ap.aging.col.invoice': 'Faktur',
  'bo.ap.aging.col.due': 'Jatuh tempo',
  'bo.ap.aging.col.daysOverdue': 'Hari terlambat',
  'bo.ap.aging.col.bucket': 'Kelompok',
  'bo.ap.aging.col.open': 'Terbuka',
  'bo.ap.aging.bucket.not_due': 'Belum jatuh tempo',
  'bo.ap.aging.bucket.d0_30': '1–30 hari',
  'bo.ap.aging.bucket.d31_60': '31–60 hari',
  'bo.ap.aging.bucket.d61_90': '61–90 hari',
  'bo.ap.aging.bucket.d90_plus': '>90 hari',
  'bo.ap.aging.totals': 'Total',
  'bo.ap.aging.expand': 'tampilkan faktur',
  'bo.ap.aging.collapse': 'sembunyikan faktur',
  'bo.ap.aging.invoiceCount': '{count} faktur terbuka',
  'bo.ap.aging.days': '{days} hari',
  'bo.ap.aging.csv': 'Ekspor CSV',
  'bo.ap.aging.definitionsTitle': 'Definisi',
  'bo.ap.aging.definitionsDesc': 'Cara server menghitung laporan ini.',
  'bo.ap.aging.definitionsNone': 'Server tidak mengirim definisi.',
  'bo.ap.aging.def.scope': 'Cakupan',
  'bo.ap.aging.def.open': 'Saldo terbuka',
  'bo.ap.aging.def.buckets': 'Kelompok umur',
  // ---- Pengaturan
  'bo.ap.settings.title': 'Pengaturan pencocokan',
  'bo.ap.settings.subtitle':
    'Toleransi pencocokan faktur pemasok dengan pesanan pembelian, berlaku untuk semua cabang',
  'bo.ap.settings.readOnly':
    'Hanya baca — mengubah pengaturan pencocokan memerlukan izin "setujui hutang".',
  'bo.ap.settings.cardTitle': 'Pencocokan faktur',
  'bo.ap.settings.cardDesc':
    'Selisih dalam toleransi ini tetap dianggap cocok; selisih yang lebih besar menjadi pengecualian yang harus diselesaikan.',
  'bo.ap.settings.price': 'Toleransi harga',
  'bo.ap.settings.priceHint': 'Harga satuan di faktur dibanding harga PO.',
  'bo.ap.settings.qty': 'Toleransi jumlah',
  'bo.ap.settings.qtyHint': 'Jumlah di faktur dibanding jumlah dipesan atau diterima.',
  'bo.ap.settings.bpsHint': '{hint} Disimpan sebagai {bps} bps.',
  'bo.ap.settings.percentInvalid': 'Isi persentase 0 sampai 100, maksimal 2 desimal.',
  'bo.ap.settings.amount': 'Toleransi nilai ({currency})',
  'bo.ap.settings.amountHint': 'Per baris faktur, dalam satuan mata uang terkecil.',
  'bo.ap.settings.amountPreview': 'Sampai',
  'bo.ap.settings.amountZero': 'Tidak ada selisih nilai yang diterima.',
  'bo.ap.settings.amountInvalid': 'Isi jumlah bulat (0 atau lebih).',
  'bo.ap.settings.mode': 'Pencocokan bawaan untuk faktur dengan pesanan pembelian',
  'bo.ap.settings.twoWay': 'Pencocokan 2 arah',
  'bo.ap.settings.twoWayHint':
    'Faktur dibanding pesanan pembelian: harga dan jumlah dipesan. Untuk jasa atau barang tanpa penerimaan.',
  'bo.ap.settings.threeWay': 'Pencocokan 3 arah',
  'bo.ap.settings.threeWayHint':
    'Faktur dibanding pesanan pembelian dan penerimaan barang: Anda hanya membayar yang benar-benar diterima. Disarankan untuk stok.',
  'bo.ap.settings.appliesNote':
    'Berlaku untuk pencocokan berikutnya; faktur yang sudah dicocokkan tetap memakai hasilnya.',
  'bo.ap.settings.submit': 'Simpan pengaturan',
  'bo.ap.settings.saved': 'Pengaturan pencocokan tersimpan.',
  'bo.ap.settings.conflict':
    'Orang lain sudah mengubah pengaturan ini. Nilai terbaru sudah dimuat — periksa lalu simpan lagi.',
  // ---- Rekonsiliasi
  'bo.recon.title': 'Rekonsiliasi',
  'bo.recon.subtitle': 'Proyeksi stok dan hutang di {branch} dicocokkan dengan buku besarnya',
  'bo.recon.noBranch': 'Rekonsiliasi dijalankan per cabang.',
  'bo.recon.noPermission':
    'Rekonsiliasi memerlukan izin persetujuan stok, audit, atau persetujuan hutang.',
  'bo.recon.refresh': 'Periksa ulang',
  'bo.recon.checking': 'Memeriksa…',
  'bo.recon.statusTitle': 'Hasil',
  'bo.recon.checkedAt': 'Diperiksa {time}',
  'bo.recon.ok': 'Sesuai',
  'bo.recon.okText': 'Semua proyeksi cocok dengan buku besarnya.',
  'bo.recon.issueBadge': '{count} selisih',
  'bo.recon.issuesText':
    'Selisih menandakan cacat data yang perlu diselidiki — jangan pernah mengubah buku besar agar cocok.',
  'bo.recon.backlog': 'Antrean pemotongan stok',
  'bo.recon.backlogCount': '{count} item pesanan',
  'bo.recon.backlogPending':
    'Item pesanan yang sudah diterima tetapi bahannya belum dipotong dari stok. Angka stok menyusul setelah diproses.',
  'bo.recon.backlogNone': 'Semua item pesanan yang diterima sudah dipotong dari stok.',
  'bo.recon.checksTitle': 'Pemeriksaan',
  'bo.recon.checksDesc': 'Setiap proyeksi dihitung ulang dari sumber yang hanya bisa ditambah.',
  'bo.recon.issuesTitle': 'Selisih',
  'bo.recon.issuesDesc': 'Seharusnya = dari buku besar; tercatat = proyeksi yang tersimpan.',
  'bo.recon.noIssues': 'Tidak ada selisih — tidak ada yang perlu diselidiki.',
  'bo.recon.unitsNote':
    'Nilai mentah: jumlah dalam seperseribu satuan dasar, uang dalam satuan mata uang terkecil.',
  'bo.recon.col.check': 'Pemeriksaan',
  'bo.recon.col.checked': 'Diperiksa',
  'bo.recon.col.issues': 'Selisih',
  'bo.recon.col.result': 'Hasil',
  'bo.recon.col.entity': 'Entitas',
  'bo.recon.col.expected': 'Seharusnya',
  'bo.recon.col.actual': 'Tercatat',
  'bo.recon.col.detail': 'Keterangan',
  'bo.recon.check.cost_pool_vs_ledger': 'Pool biaya vs buku besar stok',
  'bo.recon.check.location_balance_vs_ledger': 'Saldo lokasi vs buku besar stok',
  'bo.recon.check.lot_balance_vs_ledger': 'Saldo lot vs buku besar stok',
  'bo.recon.check.po_received_vs_receipts': 'Jumlah diterima di PO vs penerimaan barang',
  'bo.recon.check.receipt_vs_movements': 'Penerimaan barang vs mutasi stok',
  'bo.recon.check.ap_status_vs_events': 'Status faktur vs peristiwa hutang',
  'bo.recon.check.ap_negative_balance': 'Saldo hutang negatif',
  'bo.recon.hint.cost_pool_vs_ledger': 'Jumlah dan nilai per bahan.',
  'bo.recon.hint.location_balance_vs_ledger': 'Jumlah per bahan dan lokasi.',
  'bo.recon.hint.lot_balance_vs_ledger': 'Jumlah per lot.',
  'bo.recon.hint.po_received_vs_receipts': 'Jumlah diterima per baris PO.',
  'bo.recon.hint.receipt_vs_movements':
    'Jumlah diterima yang diposting ke stok per baris penerimaan.',
  'bo.recon.hint.ap_status_vs_events': 'Status lunas / lunas sebagian per faktur.',
  'bo.recon.hint.ap_negative_balance': 'Saldo terbuka per faktur tidak pernah di bawah nol.',
  'bo.recon.detail.quantity': 'Jumlah',
  'bo.recon.detail.value': 'Nilai',
  'bo.recon.detail.acceptedQty': 'Jumlah diterima (satuan PO)',
  'bo.recon.detail.baseQty': 'Jumlah satuan dasar yang diposting',
  'bo.recon.detail.negativeOpen': 'Saldo terbuka di bawah nol',
};
